import { ActionTypes } from './actions';
import { ResourceApi } from '../../resource/Resource';
import {
  TermsOfServiceResource,
  TermsOfServiceResourceAcceptTermsOfServiceByType,
  TermsOfServiceResourceGetTermsOfServiceUpdateDates,
  TermsOfServiceResourceGetTermsOfServiceNextUpdateDates,
} from '../../resource/TermsOfServiceResource/types';
import { TERMS_OF_SERVICE, WASABI } from '../resourceNames';
import { TosType } from './types';
import { ReduxState } from '../state';
import { currentUserIdSelector } from '../Auth/selectors';
import {
  WasabiResource,
  WasabiResourceScheduleTosUpdate,
} from '../../resource/WasabiResource/types';
import { Dispatch } from '../thunk';

export const retrieveTosUpdateDates = () => (
  dispatch: Dispatch,
  getState: () => ReduxState
): void => {
  if (!currentUserIdSelector(getState())) {
    return;
  }

  dispatch({
    type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_START,
  });
  ResourceApi.lookup<
    TermsOfServiceResource,
    TermsOfServiceResourceGetTermsOfServiceUpdateDates
  >(TERMS_OF_SERVICE, 'get_terms_of_service_update_dates', {}).then(
    (results) =>
      dispatch({
        type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_SUCCEED,
        dates: results,
      }),
    (error) =>
      dispatch({
        type: ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_FAILED,
        error: error.message,
      })
  );
};

export const retrieveTosNextUpdateDates = () => (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_START,
  });
  return ResourceApi.lookup<
    TermsOfServiceResource,
    TermsOfServiceResourceGetTermsOfServiceNextUpdateDates
  >(TERMS_OF_SERVICE, 'get_terms_of_service_next_update_dates', {}).then(
    (results) => {
      dispatch({
        type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_SUCCEED,
        dates: results,
      });
    },
    (error) => {
      dispatch({
        type: ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_FAILED,
        error: error.message,
      });
    }
  );
};

export const acceptTermsOfService = (tostype: TosType) => (
  dispatch: Dispatch
): void => {
  ResourceApi.execute<
    TermsOfServiceResource,
    TermsOfServiceResourceAcceptTermsOfServiceByType
  >(TERMS_OF_SERVICE, 'accept_terms_of_service_by_type', {
    type: tostype,
  }).then((result) => {
    const { timestamp, type: tosType } = result;

    return dispatch({
      type: ActionTypes.APPLICATION_TOS_ACCEPT_SUCCEED,
      timestamp,
      tosType,
    });
  });
};

export const scheduleTosUpdate = (datetime: number, types: TosType[]) => (
  dispatch: Dispatch
): Promise<void> => {
  return ResourceApi.execute<WasabiResource, WasabiResourceScheduleTosUpdate>(
    WASABI,
    'scheduleTosUpdate',
    { datetime, types }
  )
    .then(() => dispatch(retrieveTosNextUpdateDates()))
    .then(() => dispatch(retrieveTosUpdateDates()));
};
